const IMAGE_FILE_RE = /\.(png|jpe?g|gif|webp|bmp|avif)$/i;

export function isImageAttachment(filename?: string, url?: string): boolean {
  return [filename, url].some((value) => IMAGE_FILE_RE.test((value || '').split('?')[0]));
}

export async function downloadRemoteFile(url: string, filename?: string): Promise<void> {
  const res = await fetch(url, { credentials: 'omit' });
  if (!res.ok) {
    throw new Error(`Download failed: ${res.status}`);
  }
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename || url.split('/').pop() || 'download';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}

export function onAttachmentDownloadClick(
  event: Pick<
    MouseEvent,
    'preventDefault' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'button'
  >,
  url: string,
  filename?: string,
): void {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
    return;
  }
  event.preventDefault();
  downloadRemoteFile(url, filename).catch(() => {
    window.open(url, '_blank', 'noopener,noreferrer');
  });
}
